module.exports = __webpack_public_path__ + "img/colven-blanco.4ff7009e.png";